import AppDispatcher from "../dispatcher/AppDispatcher";
import { DeliveraStore } from "../model/delivera/DeliveraStore";
import { DeliveraModifierGroupInterface } from "../model/delivera/interface";
import { DeliveraCategoryInterface } from "../model/delivera/DeliveraCategorie";
import { DeliveraActionType } from "../constant/ActionConstant";
import { DeliveraItemInterface } from "../model/delivera/DeliveraItem";
import { DeliveraMenuInterface } from "../model/delivera/DeliveraMenu";

class DeliveraActionCreator {
  addGroupeModifier(
    groupeModifier: DeliveraModifierGroupInterface,
    store: DeliveraStore
  ) {
    const updatedStore = store.addGroupeModifier(groupeModifier);
    AppDispatcher.dispatch({
      type: DeliveraActionType.UPDATE_MENU,
      data: updatedStore,
    });
  }

  updateMenu(menu: DeliveraMenuInterface, store: DeliveraStore) {
    const updatedStore = store.updateMenu(menu);
    AppDispatcher.dispatch({
      type: DeliveraActionType.UPDATE_MENU,
      data: updatedStore,
    });
  }

  deleteMenu(menu: DeliveraMenuInterface, store: DeliveraStore) {
    const updatedStore = store.deleteMenu(menu);
    AppDispatcher.dispatch({
      type: DeliveraActionType.UPDATE_MENU,
      data: updatedStore,
    });
  }

  updateModifierGroupeInStore(
    modifierGroupe: DeliveraModifierGroupInterface,
    store: DeliveraStore
  ) {
    const updatedStore = store.updateGroupeModifier(modifierGroupe);
    AppDispatcher.dispatch({
      type: DeliveraActionType.UPDATE_MENU,
      data: updatedStore,
    });
  }

  removeModifierGroupeFromItemInStore(
    modifierGroupe: DeliveraModifierGroupInterface,
    item: DeliveraItemInterface,
    store: DeliveraStore
  ) {
    const updatedStore = store.removeGroupeModifierFromItem(
      modifierGroupe,
      item
    );
    AppDispatcher.dispatch({
      type: DeliveraActionType.UPDATE_MENU,
      data: updatedStore,
    });
  }

  createCategory(category: DeliveraCategoryInterface, store: DeliveraStore) {
    const updatedStore = store.createCategory(category);
    AppDispatcher.dispatch({
      type: DeliveraActionType.UPDATE_MENU,
      data: updatedStore,
    });
  }

  updateCategory(category: DeliveraCategoryInterface, store: DeliveraStore) {
    const updatedStore = store.updateCatgeory(category);
    AppDispatcher.dispatch({
      type: DeliveraActionType.UPDATE_MENU,
      data: updatedStore,
    });
  }

  addItemOnCategorieInStore(
    item: DeliveraItemInterface,
    category: DeliveraCategoryInterface,
    store: DeliveraStore
  ) {
    const updatedStore = store.addItemInCategorie(item, category);
    AppDispatcher.dispatch({
      type: DeliveraActionType.UPDATE_MENU,
      data: updatedStore,
    });
  }

  removeItemFromCategoryInStore(
    item: DeliveraItemInterface,
    category: DeliveraCategoryInterface,
    store: DeliveraStore
  ) {
    const updatedStore = store.removeItemFromCategorie(item, category);
    AppDispatcher.dispatch({
      type: DeliveraActionType.UPDATE_MENU,
      data: updatedStore,
    });
  }

  removeItem(item: DeliveraItemInterface, store: DeliveraStore) {
    const updatedStore = store.removeItem(item);
    AppDispatcher.dispatch({
      type: DeliveraActionType.UPDATE_MENU,
      data: updatedStore,
    });
  }

  addItemOnStore(item: DeliveraItemInterface, store: DeliveraStore) {
    const updatedStore = store.addItem(item);
    AppDispatcher.dispatch({
      type: DeliveraActionType.UPDATE_MENU,
      data: updatedStore,
    });
  }

  updateItemOnStore(item: DeliveraItemInterface, store: DeliveraStore) {
    const updatedStore = store.updateItem(item);
    AppDispatcher.dispatch({
      type: DeliveraActionType.UPDATE_MENU,
      data: updatedStore,
    });
  }
}

const deliveraActionCreator = new DeliveraActionCreator();
export default deliveraActionCreator;
